const GetUserName = () => {
  const userName = window.localStorage.getItem('user');

  return userName;
};

export default GetUserName;
